<table class="table table-naked history-table">
  @for (entry of historyEntries.value(); track entry.timestamp) {
    <tr class="history-action-{{entry.action.id}}">
      <td [innerText]="entry.timestamp | date:'dd.MM.yyyy HH:mm'"></td>
      <td [innerText]="entry.action.messageCode | translate"></td>
      <td [innerText]="entry.user"></td>
    </tr>
  }
</table>

<style>
  .history-table {
    text-align: left;
  }
  .history-action-0 {
    color: darkgray;
    font-style: italic;
  }
</style>
